/**
 * API Configuration
 * Centralized configuration for API endpoints and settings
 */

export const API_CONFIG = {
  BASE_URL:  'https://sandbox.qurexdev.in',
  AUTH_BASE_URL: 'https://api.qurexdev.in',
  TIMEOUT: 60000, // 60 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second
  ENDPOINTS: {
    HEALTH: '/api/v1/health',
    ANALYZE: '/api/v1/analyze',
    LOGIN: '/api/v1/admin/dc-copilot-login',
    APPOINTMENTS: '/api/v1/admin/getDcCopliotAppoinments',
    FORM_SCHEMA: '/api/v1/admin/dc-copilot-form-schema',
    SAVE_FORM: '/api/v1/admin/dc-copilot-form/save-complete',
    GET_FORM_DATA: '/api/v1/admin/dc-copilot-form/get-complete',
    UPDATE_FORM: '/api/v1/admin/dc-copilot-form/update-complete',
    UPDATE_USER_HISTORY: '/api/v1/admin/dc-copilot-form/update-user-history',
    PACKAGE_LIST: '/api/v1/user/packageList',
  },
} as const;

export type ApiEndpoint = keyof typeof API_CONFIG.ENDPOINTS;

/**
 * Get full URL for an endpoint
 */
export function getEndpointUrl(endpoint: ApiEndpoint): string {
  return `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS[endpoint]}`;
}

/**
 * Check if we're in development mode
 */
export const isDevelopment = Boolean((import.meta as any).env?.DEV);

/**
 * Check if we're in production mode
 */
export const isProduction = Boolean((import.meta as any).env?.PROD);

